import { extractErrorMessage } from '@messenger/utils'

export const getErrorMessage = (error: unknown): string =>
  extractErrorMessage(error).message
